import { createSlice } from '@reduxjs/toolkit'
import type { GameSession } from '../../types/session.types'
import {
    addPlayerToSession,
    fetchActiveSession,
    fetchCurrentUserActiveSessions,
    fetchSessionHistory,
    finishSet
} from "../thunks/sessionThunks.ts";

interface SessionsState {
    activeSessions: Record<number, GameSession> // Key: tableId
    currentUserActiveSessions: GameSession[]
    sessionHistory: GameSession[]
    selectedSession: GameSession | null
    loading: boolean
    error: string | null
}

const initialState: SessionsState = {
    activeSessions: {},
    currentUserActiveSessions: [],
    sessionHistory: [],
    selectedSession: null,
    loading: false,
    error: null
}

const sessionsSlice = createSlice({
    name: 'sessions',
    initialState,
    reducers: {
        setSelectedSession: (state, action) => {
            state.selectedSession = action.payload
        },
        clearActiveSession: (state, action) => {
            delete state.activeSessions[action.payload]
        },
        clearError: (state) => {
            state.error = null
        }
    },
    extraReducers: (builder) => {
        // Fetch Active Session
        builder.addCase(fetchActiveSession.pending, (state) => {
            state.loading = true
            state.error = null
        })
        builder.addCase(fetchActiveSession.fulfilled, (state, action) => {
            if (action.payload) {
                state.activeSessions[action.payload.tableId] = action.payload
            }
            state.loading = false
        })
        builder.addCase(fetchActiveSession.rejected, (state, action) => {
            state.loading = false
            state.error = action.payload as string
        })

        builder.addCase(fetchCurrentUserActiveSessions.pending, (state) => {
            state.loading = true
            state.error = null
        })
        builder.addCase(fetchCurrentUserActiveSessions.fulfilled, (state, action) => {
            state.currentUserActiveSessions = action.payload
            action.payload.forEach(session => {
                state.activeSessions[session.tableId] = session
            })
            state.loading = false
        })
        builder.addCase(fetchCurrentUserActiveSessions.rejected, (state, action) => {
            state.loading = false
            state.error = action.payload as string
        })

        // Fetch Session History
        builder.addCase(fetchSessionHistory.fulfilled, (state, action) => {
            state.sessionHistory = action.payload.content
        })

        // Add Player
        builder.addCase(addPlayerToSession.fulfilled, (state) => {
            // Session will be refreshed by thunk
        })

        // Finish Set
        builder.addCase(finishSet.fulfilled, (state) => {
            // Session will be refreshed by thunk
        })
    }
})

export const { setSelectedSession, clearActiveSession, clearError } = sessionsSlice.actions
export default sessionsSlice.reducer